import axios from "axios";
import { IAdministratorParameters } from "../models/administratorSettings";


export const getAdministratorParameters = async () => {
    const res = await axios.get("/api/administratorSettings");
    return res.data as IAdministratorParameters;
};

export const editAdministratorParametersAsync = async (data: IAdministratorParameters) => {
    await axios.patch("/api/administratorSettings", data);
};

